import * as i0 from '@angular/core';
import { booleanAttribute, HostBinding, Input, Component, EventEmitter, Output, Directive, NgModule } from '@angular/core';
import { CrntButtonAlt as CrntButtonAlt$1, CrntCheckboxGroup as CrntCheckboxGroup$1, CrntCheckbox as CrntCheckbox$1, CrntComponentLoader as CrntComponentLoader$1, CrntFormControlHelpText as CrntFormControlHelpText$1, CrntFormControlLabelIndicator as CrntFormControlLabelIndicator$1, CrntFormControlLabel as CrntFormControlLabel$1, CrntFormControlValidationMessage as CrntFormControlValidationMessage$1, CrntFormControl as CrntFormControl$1, CrntIconButtonAlt as CrntIconButtonAlt$1, CrntIconButton as CrntIconButton$1, CrntIcon as CrntIcon$1, CrntRadioGroup as CrntRadioGroup$1, CrntRadio as CrntRadio$1, CrntSelect as CrntSelect$1, CrntTextInput as CrntTextInput$1, CrntTooltipAlternative as CrntTooltipAlternative$1, CrntVisuallyHidden as CrntVisuallyHidden$1 } from '@essent/current-web';
import { CrntButton as CrntButton$1 } from '@essent/current-web/dist/components/button/button.component';
import { CrntCallout as CrntCallout$1 } from '@essent/current-web/dist/components/callout/callout.component';
import { CrntProse as CrntProse$1 } from '@essent/current-web/dist/components/prose/prose.component';
import * as i1 from '@angular/router';
import { UrlTree } from '@angular/router';

CrntButtonAlt$1.define();
class CrntButtonAlt {
    state = 'enabled';
    variant = 'primary';
    /**
     * @region fullWidth
     */
    fullWidth = false;
    get _fullWidth() {
        return this.fullWidth ? 'full-width' : null;
    }
    /**
     * @region inverted
     */
    inverted = false;
    get _inverted() {
        return this.inverted ? 'inverted' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntButtonAlt, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntButtonAlt, isStandalone: true, selector: "crnt-button-alt", inputs: { state: "state", variant: "variant", fullWidth: ["fullWidth", "fullWidth", booleanAttribute], inverted: ["inverted", "inverted", booleanAttribute] }, host: { properties: { "attr.state": "this.state", "attr.variant": "this.variant", "attr.full-width": "this._fullWidth", "attr.inverted": "this._inverted" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntButtonAlt, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-button-alt',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }], variant: [{
                type: HostBinding,
                args: ['attr.variant']
            }, {
                type: Input
            }], fullWidth: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _fullWidth: [{
                type: HostBinding,
                args: ['attr.full-width']
            }], inverted: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _inverted: [{
                type: HostBinding,
                args: ['attr.inverted']
            }] } });

CrntButton$1.define();
class CrntButton {
    _elementRef;
    blur = new EventEmitter();
    click = new EventEmitter();
    crntBlur = new EventEmitter();
    crntFocus = new EventEmitter();
    focus = new EventEmitter();
    href;
    state = 'enabled';
    target;
    type;
    variant = 'primary';
    /**
     * @region fullWidth
     */
    fullWidth = false;
    get _fullWidth() {
        return this.fullWidth ? 'full-width' : null;
    }
    /**
     * @region inverted
     */
    inverted = false;
    get _inverted() {
        return this.inverted ? 'inverted' : null;
    }
    /**
     * @region Properly handle disabled states
     * Angular does not respect stopImmediatePropagation from coming from other elements
     * https://github.com/angular/angular/issues/9587
     * https://github.com/angular/angular/issues/47463
     * This explicit workaround using elementRef is respected by the Angular event engine.
     */
    get _isDisabled() {
        return ['disabled', 'processing', 'success'].includes(this.state);
    }
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this._elementRef.nativeElement.addEventListener('click', this._handleClick.bind(this));
    }
    ngOnDestroy() {
        this._elementRef.nativeElement.removeEventListener('click', this._handleClick.bind(this));
    }
    _handleClick(event) {
        if (this._isDisabled) {
            event.stopImmediatePropagation();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntButton, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntButton, isStandalone: true, selector: "crnt-button", inputs: { href: "href", state: "state", target: "target", type: "type", variant: "variant", fullWidth: ["fullWidth", "fullWidth", booleanAttribute], inverted: ["inverted", "inverted", booleanAttribute] }, outputs: { blur: "blur", click: "click", crntBlur: "crnt-blur", crntFocus: "crnt-focus", focus: "focus" }, host: { properties: { "attr.href": "this.href", "attr.state": "this.state", "attr.target": "this.target", "attr.type": "this.type", "attr.variant": "this.variant", "attr.full-width": "this._fullWidth", "attr.inverted": "this._inverted" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-button',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { blur: [{
                type: Output,
                args: ['blur']
            }], click: [{
                type: Output,
                args: ['click']
            }], crntBlur: [{
                type: Output,
                args: ['crnt-blur']
            }], crntFocus: [{
                type: Output,
                args: ['crnt-focus']
            }], focus: [{
                type: Output,
                args: ['focus']
            }], href: [{
                type: HostBinding,
                args: ['attr.href']
            }, {
                type: Input
            }], state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }], target: [{
                type: HostBinding,
                args: ['attr.target']
            }, {
                type: Input
            }], type: [{
                type: HostBinding,
                args: ['attr.type']
            }, {
                type: Input
            }], variant: [{
                type: HostBinding,
                args: ['attr.variant']
            }, {
                type: Input
            }], fullWidth: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _fullWidth: [{
                type: HostBinding,
                args: ['attr.full-width']
            }], inverted: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _inverted: [{
                type: HostBinding,
                args: ['attr.inverted']
            }] } });

CrntCallout$1.define();
class CrntCallout {
    variant = 'informative';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntCallout, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntCallout, isStandalone: true, selector: "crnt-callout", inputs: { variant: "variant" }, host: { properties: { "attr.variant": "this.variant" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntCallout, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-callout',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { variant: [{
                type: HostBinding,
                args: ['attr.variant']
            }, {
                type: Input
            }] } });

CrntCheckboxGroup$1.define();
class CrntCheckboxGroup {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntCheckboxGroup, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntCheckboxGroup, isStandalone: true, selector: "crnt-checkbox-group", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntCheckboxGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-checkbox-group',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }] } });

CrntCheckbox$1.define();
class CrntCheckbox {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    /**
     * @region bordered
     */
    bordered = false;
    get _bordered() {
        return this.bordered ? 'bordered' : null;
    }
    /**
     * @region state
     */
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntCheckbox, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntCheckbox, isStandalone: true, selector: "crnt-checkbox", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute], bordered: ["bordered", "bordered", booleanAttribute], state: "state" }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink", "attr.bordered": "this._bordered", "attr.state": "this.state" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntCheckbox, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-checkbox',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }], bordered: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _bordered: [{
                type: HostBinding,
                args: ['attr.bordered']
            }], state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntComponentLoader$1.define();
class CrntComponentLoader {
    animation;
    timeout;
    /**
     * @region defined
     */
    defined = false;
    get _defined() {
        return this.defined ? 'defined' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntComponentLoader, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntComponentLoader, isStandalone: true, selector: "crnt-component-loader", inputs: { animation: "animation", timeout: "timeout", defined: ["defined", "defined", booleanAttribute] }, host: { properties: { "attr.animation": "this.animation", "attr.timeout": "this.timeout", "attr.defined": "this._defined" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntComponentLoader, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-component-loader',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { animation: [{
                type: HostBinding,
                args: ['attr.animation']
            }, {
                type: Input
            }], timeout: [{
                type: HostBinding,
                args: ['attr.timeout']
            }, {
                type: Input
            }], defined: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _defined: [{
                type: HostBinding,
                args: ['attr.defined']
            }] } });

CrntFormControlHelpText$1.define();
class CrntFormControlHelpText {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlHelpText, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntFormControlHelpText, isStandalone: true, selector: "crnt-form-control-help-text", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlHelpText, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-control-help-text',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormControlLabelIndicator$1.define();
class CrntFormControlLabelIndicator {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlLabelIndicator, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntFormControlLabelIndicator, isStandalone: true, selector: "crnt-form-control-label-indicator", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlLabelIndicator, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-control-label-indicator',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormControlLabel$1.define();
class CrntFormControlLabel {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlLabel, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntFormControlLabel, isStandalone: true, selector: "crnt-form-control-label", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlLabel, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-control-label',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormControlValidationMessage$1.define();
class CrntFormControlValidationMessage {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlValidationMessage, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntFormControlValidationMessage, isStandalone: true, selector: "crnt-form-control-validation-message", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControlValidationMessage, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-control-validation-message',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

CrntFormControl$1.define();
class CrntFormControl {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControl, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntFormControl, isStandalone: true, selector: "crnt-form-control", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntFormControl, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-form-control',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }] } });

CrntIconButtonAlt$1.define();
class CrntIconButtonAlt extends CrntButtonAlt {
    /**
     * Author the state of the button.
     */
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntIconButtonAlt, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntIconButtonAlt, isStandalone: true, selector: "crnt-icon-button-alt", inputs: { state: "state" }, host: { properties: { "attr.state": "this.state" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntIconButtonAlt, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-icon-button-alt',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntIconButton$1.define();
class CrntIconButton extends CrntButton {
    /**
     * Author the state of the button.
     */
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntIconButton, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntIconButton, isStandalone: true, selector: "crnt-icon-button", inputs: { state: "state" }, host: { properties: { "attr.state": "this.state" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntIconButton, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-icon-button',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntIcon$1.define();
class CrntIcon {
    animation;
    ariaLabel;
    icon;
    size = 'base';
    /**
     * @region square
     */
    square = false;
    get _square() {
        return this.square ? 'square' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntIcon, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntIcon, isStandalone: true, selector: "crnt-icon", inputs: { animation: "animation", ariaLabel: "ariaLabel", icon: "icon", size: "size", square: ["square", "square", booleanAttribute] }, host: { properties: { "attr.animation": "this.animation", "attr.aria-label": "this.ariaLabel", "attr.icon": "this.icon", "attr.size": "this.size", "attr.square": "this._square" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntIcon, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-icon',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { animation: [{
                type: HostBinding,
                args: ['attr.animation']
            }, {
                type: Input
            }], ariaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }, {
                type: Input
            }], icon: [{
                type: HostBinding,
                args: ['attr.icon']
            }, {
                type: Input
            }], size: [{
                type: HostBinding,
                args: ['attr.size']
            }, {
                type: Input
            }], square: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _square: [{
                type: HostBinding,
                args: ['attr.square']
            }] } });

CrntProse$1.define();
class CrntProse {
    variant = 'expressive';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntProse, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntProse, isStandalone: true, selector: "crnt-prose", inputs: { variant: "variant" }, host: { properties: { "attr.variant": "this.variant" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntProse, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-prose',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { variant: [{
                type: HostBinding,
                args: ['attr.variant']
            }, {
                type: Input
            }] } });

CrntRadioGroup$1.define();
class CrntRadioGroup {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntRadioGroup, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntRadioGroup, isStandalone: true, selector: "crnt-radio-group", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute] }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntRadioGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-radio-group',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }] } });

CrntRadio$1.define();
class CrntRadio {
    /**
     * @region disableAutoLink
     */
    disableAutoLink = false;
    get _disableAutoLink() {
        return this.disableAutoLink ? 'disable-auto-link' : null;
    }
    /**
     * @region bordered
     */
    bordered = false;
    get _bordered() {
        return this.bordered ? 'bordered' : null;
    }
    /**
     * @region state
     */
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntRadio, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "18.2.14", type: CrntRadio, isStandalone: true, selector: "crnt-radio", inputs: { disableAutoLink: ["disableAutoLink", "disableAutoLink", booleanAttribute], bordered: ["bordered", "bordered", booleanAttribute], state: "state" }, host: { properties: { "attr.disable-auto-link": "this._disableAutoLink", "attr.bordered": "this._bordered", "attr.state": "this.state" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntRadio, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-radio',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { disableAutoLink: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _disableAutoLink: [{
                type: HostBinding,
                args: ['attr.disable-auto-link']
            }], bordered: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], _bordered: [{
                type: HostBinding,
                args: ['attr.bordered']
            }], state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntSelect$1.define();
class CrntSelect {
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntSelect, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntSelect, isStandalone: true, selector: "crnt-select", inputs: { state: "state" }, host: { properties: { "attr.state": "this.state" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntSelect, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-select',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntTextInput$1.define();
class CrntTextInput {
    state = 'enabled';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTextInput, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntTextInput, isStandalone: true, selector: "crnt-text-input", inputs: { state: "state" }, host: { properties: { "attr.state": "this.state" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTextInput, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-text-input',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { state: [{
                type: HostBinding,
                args: ['attr.state']
            }, {
                type: Input
            }] } });

CrntTooltipAlternative$1.define();
class CrntTooltipAlternative {
    _elementRef;
    closeButtonLabel = 'Close';
    dialogTitle = null;
    toggleButtonIcon = 'info-circle';
    toggleButtonLabel;
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    /**
     * Programmatically closes the tooltip dialog.
     */
    close() {
        this._elementRef.nativeElement.close();
    }
    /**
     * Programmatically opens the tooltip dialog.
     */
    showModal() {
        this._elementRef.nativeElement.showModal();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTooltipAlternative, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntTooltipAlternative, isStandalone: true, selector: "crnt-tooltip-alternative", inputs: { closeButtonLabel: "closeButtonLabel", dialogTitle: "dialogTitle", toggleButtonIcon: "toggleButtonIcon", toggleButtonLabel: "toggleButtonLabel" }, host: { properties: { "attr.close-button-label": "this.closeButtonLabel", "attr.dialog-title": "this.dialogTitle", "attr.toggle-button-icon": "this.toggleButtonIcon", "attr.toggle-button-label": "this.toggleButtonLabel" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTooltipAlternative, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-tooltip-alternative',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { closeButtonLabel: [{
                type: HostBinding,
                args: ['attr.close-button-label']
            }, {
                type: Input
            }], dialogTitle: [{
                type: HostBinding,
                args: ['attr.dialog-title']
            }, {
                type: Input
            }], toggleButtonIcon: [{
                type: HostBinding,
                args: ['attr.toggle-button-icon']
            }, {
                type: Input
            }], toggleButtonLabel: [{
                type: HostBinding,
                args: ['attr.toggle-button-label']
            }, {
                type: Input,
                args: [{ required: true }]
            }] } });

CrntVisuallyHidden$1.define();
class CrntVisuallyHidden {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntVisuallyHidden, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.14", type: CrntVisuallyHidden, isStandalone: true, selector: "crnt-visually-hidden", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntVisuallyHidden, decorators: [{
            type: Component,
            args: [{
                    selector: 'crnt-visually-hidden',
                    standalone: true,
                    template: '<ng-content></ng-content>',
                }]
        }] });

class CrntRouterLink {
    _el;
    _router;
    href;
    routerLink;
    constructor(_el, _router) {
        this._el = _el;
        this._router = _router;
    }
    static isUrlTree(v) {
        return v instanceof UrlTree;
    }
    ngOnInit() {
        if (this.routerLink) {
            if (typeof this.routerLink === 'string') {
                this.href = this.routerLink;
            }
            else if (CrntRouterLink.isUrlTree(this.routerLink)) {
                this.href = this._router.serializeUrl(this.routerLink);
            }
            const anchorTag = this._el.nativeElement.shadowRoot?.querySelector('a');
            anchorTag?.addEventListener('click', (e) => {
                e.preventDefault();
            });
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntRouterLink, deps: [{ token: i0.ElementRef }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.14", type: CrntRouterLink, isStandalone: true, selector: "[routerLink]", inputs: { routerLink: "routerLink" }, host: { properties: { "attr.href": "this.href" } }, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntRouterLink, decorators: [{
            type: Directive,
            args: [{
                    selector: '[routerLink]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1.Router }], propDecorators: { href: [{
                type: HostBinding,
                args: ['attr.href']
            }], routerLink: [{
                type: Input
            }] } });

const imports = [
    CrntButtonAlt,
    CrntButton,
    CrntCheckboxGroup,
    CrntCheckbox,
    CrntComponentLoader,
    CrntFormControlHelpText,
    CrntFormControlLabelIndicator,
    CrntFormControlLabel,
    CrntFormControlValidationMessage,
    CrntFormControl,
    CrntIconButtonAlt,
    CrntIconButton,
    CrntIcon,
    CrntRadioGroup,
    CrntRadio,
    CrntSelect,
    CrntTextInput,
    CrntVisuallyHidden,
];
class CrntTestingModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.14", ngImport: i0, type: CrntTestingModule, imports: [CrntButtonAlt,
            CrntButton,
            CrntCheckboxGroup,
            CrntCheckbox,
            CrntComponentLoader,
            CrntFormControlHelpText,
            CrntFormControlLabelIndicator,
            CrntFormControlLabel,
            CrntFormControlValidationMessage,
            CrntFormControl,
            CrntIconButtonAlt,
            CrntIconButton,
            CrntIcon,
            CrntRadioGroup,
            CrntRadio,
            CrntSelect,
            CrntTextInput,
            CrntVisuallyHidden] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTestingModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.14", ngImport: i0, type: CrntTestingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CrntButton, CrntButtonAlt, CrntCallout, CrntCheckbox, CrntCheckboxGroup, CrntComponentLoader, CrntFormControl, CrntFormControlHelpText, CrntFormControlLabel, CrntFormControlLabelIndicator, CrntFormControlValidationMessage, CrntIcon, CrntIconButton, CrntIconButtonAlt, CrntProse, CrntRadio, CrntRadioGroup, CrntRouterLink, CrntSelect, CrntTestingModule, CrntTextInput, CrntTooltipAlternative, CrntVisuallyHidden, imports };
